// Library -> Apps: "1 App matches in Apps →" opens the Apps place already searching for the same words.
// One value, taken once by the Apps list when it opens; nothing else reads or keeps it.
let pending: string | null = null;
export const handOffAppsSearch = (query: string) => {
  pending = query.trim() || null;
};
export const takeAppsSearch = (): string => {
  const query = pending ?? '';
  pending = null;
  return query;
};
